import BaseModel from './base';

class BillingModel extends BaseModel {
	getInfo() {
		return this.get('');
	}

	async update(body) {
		return this.patch('/tax-information', { body });
	}

	async changePlan(body) {
		return this.patch('/tax-information', { body });
	}

	validateVat(vat) {
		return this.get(`/validate-vat?vat=${vat}`);
	}
}

export default new BillingModel('/billing');
